export default __webpack_public_path__ + "static/media/add-building-success.3936b3ff.png";